export function decodeSafeURI(uri: string) {
    try {
        return decodeURI(uri);
    } catch (error) {
        return uri;
    }
}